import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
const MOCKUP_SRC = 'https://cdn.magicpatterns.com/uploads/urmAUFLxkpqtXbpPsHt4K3/ChatGPT_Image_12_sept_2026,_16_36_13-Photoroom.png';
export function HeroSection() {
  return <section id="top" aria-labelledby="hero-title" className="flex min-h-[calc(100svh-2.25rem)] items-center bg-brand-cream px-4 py-8 md:px-8" data-id="element-105" data-mp="23x4hac790bub">
      <motion.div initial={{
      opacity: 0,
      y: 18
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} className="mx-auto grid w-full max-w-content items-center gap-8 lg:grid-cols-[minmax(0,1fr)_minmax(0,1.15fr)] lg:gap-10" data-id="element-106" data-mp="2wl0h3ps46jvb">
        <div className="flex flex-col items-center text-center lg:items-start lg:text-left" data-id="element-107" data-mp="2rrpdrymigl85">
          <p className="mb-3 text-[10px] font-extrabold uppercase tracking-[0.16em] text-brand-teal sm:text-xs" data-id="element-108" data-mp="3fht8thlmvcnj">
            PRIMARIA, MEDIE E SUPERIORI · ETÀ 6-19 ANNI
          </p>
          <h1 id="hero-title" className="text-[1.85rem] font-extrabold leading-[1.08] tracking-tight text-brand-primary sm:text-[2.4rem] lg:text-[3.1rem]" data-id="element-109" data-mp="2feqnr3udsc9s">
            Insegna un Anno Intero di <span className="italic text-brand-accent" data-id="element-110" data-mp="2p63iq4bh7ik1">Educazione Fisica</span> in Soli 5
            Minuti di Preparazione
          </h1>
          <p className="mt-4 max-w-lg text-[13px] leading-relaxed text-brand-gray sm:text-sm lg:text-base" data-id="element-111" data-mp="2kcs8dt7ggjnd">
            <strong className="font-bold text-brand-text" data-id="element-112" data-mp="2u4es6dxuzr1q">EDUCAZIONE FISICA PRONTA™</strong> è il{' '}
            <strong className="font-bold text-brand-text" data-id="element-113" data-mp="3847ii85h4596">curricolo motorio completo</strong>, pronto all&apos;uso, per
            la scuola italiana. <strong className="font-bold text-brand-text" data-id="element-114" data-mp="3365ur9x3rhrd">8 volumi</strong>,{' '}
            <strong className="font-bold text-brand-text" data-id="element-115" data-mp="1dpd7u7w3y2k3">64 unità didattiche</strong>,{' '}
            <strong className="font-bold text-brand-text" data-id="element-116" data-mp="18rlf5bnn2ceu">2.752 esercizi già pronti</strong>: zero ore a preparare le
            lezioni da zero.
          </p>

          <img src={MOCKUP_SRC} alt="Il pacchetto EDUCAZIONE FISICA PRONTA: gli 8 volumi, i materiali digitali su tablet e computer e i 5 bonus inclusi" className="mx-auto my-5 h-[34svh] w-auto max-w-full object-contain sm:h-[38svh] lg:hidden" data-id="element-117" data-mp="38vfod27u2m1z" />

          <div className="mt-2 flex w-full flex-col items-center lg:mt-8 lg:items-start" data-id="element-118" data-mp="3muf8bwkeicrt">
            <CTAButton className="w-full max-w-sm px-5 py-4 text-[11px] sm:text-xs lg:w-auto lg:text-sm" data-id="element-119" data-mp="3rrx9v1w39pps" />
            <p className="mt-2.5 text-[10px] font-semibold leading-relaxed text-brand-gray" data-id="element-120" data-mp="k1i5r7vxq5v">
              ✓ Pagamento unico <span className="px-1 text-brand-yellow" data-id="element-121" data-mp="5eyrz0czo3jt">·</span> ✓ Accesso immediato
              <span className="px-1 text-brand-yellow" data-id="element-122" data-mp="aaw5kywvavsw">·</span> ✓ Pronto da stampare
            </p>
          </div>
        </div>

        <img src={MOCKUP_SRC} alt="" aria-hidden="true" className="hidden max-h-[86svh] w-full object-contain lg:block" data-id="element-123" data-mp="jcdm2ie6szi4" />
      </motion.div>
    </section>;
}